<template>
    <div class="wallet-marquee">
    <div class="container">
    <marquee :speed="60" class="announcement-msg" v-if="walletConfig?.announcement?.value">
        {{walletConfig?.announcement?.value}}
    </marquee>
    </div>
    </div>
</template>

<script>
import { marquee } from '@template/utils';
export default {
    name: 'WalletAnnoucement',
    inject: ['walletConfig'],
    components: {
        marquee
    }
}
</script>